import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { OnboardingStage } from '../models';
import { Coverage3dOnboardingDeviceBehaviorService } from '../services';

@Pipe({ name: 'onboardingStageDescription', standalone: true })
export class OnboardingStageDescriptionPipe implements PipeTransform {
	private readonly transloco = inject(TranslocoService);
	private readonly deviceBehavior = inject(Coverage3dOnboardingDeviceBehaviorService);

	public transform(stage: OnboardingStage, model: DeviceModel): string {
		// Prioritize the device-specific description if available
		const description = this.deviceBehavior.getStageDescription(model, stage);
		if (description) {
			return description;
		}

		// Apply default descriptions based on the stage if no device-specific description is available
		switch (stage) {
			case OnboardingStage.Introduction:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-stages.introduction.description', {
					deviceModel: model
				});
			case OnboardingStage.Completed:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-stages.completed.description', {
					deviceModel: model
				});
			case OnboardingStage.InProgress:
			default:
				return '';
		}
	}
}
